module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesCool.3991b4f.webp";